/**
 * @deprecated
 */
export function formatPhoneNumber(phoneNumber?: string | null) {
  if (!phoneNumber) return null;

  return phoneNumber;
}
